<div class="overlay" (mousedown)="onBackdrop($event)">
  <div class="dialog" role="alertdialog" aria-modal="true" aria-labelledby="cancel-title" aria-describedby="cancel-desc">
    <header>
      <h3 id="cancel-title">Cancel this schedule?</h3>
      <button type="button" class="x" aria-label="Close" [disabled]="saving" (click)="close()">&times;</button>
    </header>

    <div class="body">
      <p class="sub">{{ form.schedule_id }}</p>
      <div class="warn-box" id="cancel-desc">
        The patch window <strong>{{ form.window_text }}</strong> for
        {{ form.servers.length }} server{{ form.servers.length == 1 ? '' : 's' }} will not run.
      </div>
      <label class="field">
        <span>Reason for cancelling (required)</span>
        <textarea rows="3" maxlength="300" [value]="reason" (input)="onReasonInput($event)"
          placeholder="e.g. Change freeze requested by the customer"></textarea>
      </label>
    </div>

    <footer>
      <button #keepBtn type="button" class="cs-btn cs-btn-outline" [disabled]="saving" (click)="close()">
        <span>Keep schedule</span>
      </button>
      <button type="button" class="cs-btn cs-btn-danger" [disabled]="!canConfirm" (click)="submit()">
        <span>{{ confirmLabel }}</span>
      </button>
    </footer>
  </div>
</div>